import { ArrowLeftIcon, ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Button, Flex, FlexProps, Select, Text } from "@chakra-ui/react";

export interface PaginationProps extends FlexProps {
  toPage1?: () => void;
  toLastPage?: () => void;
  toPrevious?: () => void;
  toNext?: () => void;

  itemsPerPageChoices?: number[];
  itemsPerPage?: number;
  setItemsPerPage?: (amount: number) => void;

  page?: number;
  numPages?: number;

  variant?: string;
}

export function Pagination({
  toPage1,
  toLastPage,
  toPrevious,
  toNext,
  itemsPerPageChoices = [10, 20, 40],
  itemsPerPage,
  setItemsPerPage,
  page,
  numPages = 0,
  variant,
  ...rest
}: PaginationProps) {
  return (
    <Flex mt={4} justifyContent="flex-end" alignItems="center" gap={2} {...rest}>
      <Button isDisabled={toPage1 === undefined} onClick={toPage1} p={1} variant={variant}>
        <ArrowLeftIcon />
      </Button>
      <Button isDisabled={toPrevious === undefined} onClick={toPrevious} p={1} variant={variant}>
        <ChevronLeftIcon />
      </Button>
      {numPages > 0 ? (
        <Text margin={0}>
          {page} / {numPages}
        </Text>
      ) : null}
      <Button isDisabled={toNext === undefined} onClick={toNext} p={1} variant={variant}>
        <ChevronRightIcon />
      </Button>
      <Button isDisabled={toLastPage === undefined} onClick={toLastPage} variant={variant}>
        <ArrowRightIcon />
      </Button>
      {setItemsPerPage !== undefined ? (
        <Select
          value={itemsPerPage}
          onChange={(event) => setItemsPerPage(parseInt(event.target.value))}
          w={"150px"}
        >
          {itemsPerPageChoices.map((choice) => (
            <option key={choice} value={choice}>
              {choice} per page
            </option>
          ))}
        </Select>
      ) : null}
    </Flex>
  );
}
